<template>
  <div class="is-flex is-justify-content-center is-flex-direction-column">
    <select dir="rtl" v-model="email">
      <option v-for="(emailItem, idx) in emailList" :key="idx" :value="email">{{ emailItem }} </option>
    </select>
    <div class="my-5 mx-auto">
      <button @click="sendInvitation" class="button is-info">Send Invitation</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyInvitation',
  props: {
    payload: {
      type: Object
    },
    defaultEmail: {
      type: String,
      require: true
    },
    emailList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      email: this.defaultEmail
    }
  },
  methods: {
    sendInvitation () {
      alert('Sorry, this feature will activate soon. Thank you for your cooperation.')
    }
  }
}
</script>
